// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dfdb0d71","455":"ec63873d","977":"3473ec9e"}[chunkId] + ".chunk.js";
};